import { setInteractionMode } from 'vee-validate'
import { integer, required, email, min, max } from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'
import { i18n } from '../extend'

setInteractionMode('eager')

extend('email', { ...email })
extend('integer', { ...integer })
extend('max', { ...max })
extend('min', { ...min })
extend('required', { ...required })
extend('decimal', value => {
  if (Number.parseFloat(value) === +value) return true

  return i18n.t('errorRule.decimal')
})
extend('positive', value => {
  if (+value >= 0) return true

  return i18n.t('errorRule.positive')
})
